import moment from 'moment/moment';
import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  COMPOSED_COUNTRY_SELECT_EXTEND_TYPE,
  REGION_CASCADER_SELECT,
  // 单选区域筛选器
  SINGLE_AREA_SELECT as SINGLE_AREA_SELECT_FILTER,
  SINGLE_AREA_SELECT_EXTEND_TYPE,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

const DEFAULT_RANGE_TIME_VALUES = {
  // 当月， 最近1周， 当天
  date: [moment(), moment()],
  week: [moment().startOf('week'), moment().endOf('week')],
  month: [moment().startOf('month'), moment().startOf('month')],
};

/**
 * 判断每一个date是否有效（配置的props名字disabledDate 语意刚好是相反的）
 * 这里是禁用当天以后的日期
 * @param date Moment日期对象
 * @return 当前date是否有效
 */
const isValidDate = (date: moment.Moment): boolean => {
  if (!date?.isValid()) return true;
  return date?.isSameOrBefore(moment(), 'day');
};

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  RANGE_TIME_SELECT_FILTER: {
    key: RANGE_TIME_SELECT_FILTER,
    type: RANGE_TIME_SELECT_FILTER,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
    componentDefault: DEFAULT_RANGE_TIME_VALUES,
  },
  COMPOSED_COUNTRY_SELECT_FILTER: {
    key: COMPOSED_COUNTRY_SELECT_FILTER,
    type: REGION_CASCADER_SELECT,
    className: 'dbi-console-store-rank_composed-country-select',
    extendFilterType: COMPOSED_COUNTRY_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    disabledLabel: '',
    isShowTypeSelect: false,
    footer: null,
    options: [],
    title: 'dbi_region',
    placeholder: 'dbi_select_region',
  },
  SINGLE_AREA_SELECT_FILTER: {
    key: SINGLE_AREA_SELECT_FILTER,
    type: SINGLE_AREA_SELECT_FILTER,
    className: '',
    extendFilterType: SINGLE_AREA_SELECT_EXTEND_TYPE.common,
    visible: 2,
    disabled: false,
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  [RANGE_TIME_SELECT_FILTER]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [COMPOSED_COUNTRY_SELECT_FILTER]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [SINGLE_AREA_SELECT_FILTER]: {
    value: '',
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  STATIC_FILTER_CONFIGS.RANGE_TIME_SELECT_FILTER,
  STATIC_FILTER_CONFIGS.COMPOSED_COUNTRY_SELECT_FILTER,
  STATIC_FILTER_CONFIGS.SINGLE_AREA_SELECT_FILTER,
];
